import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import api, { setToken } from "@/lib/api";
import { Layers } from "lucide-react";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      navigate("/login", { replace: true });
      return;
    }
    const sessionId = decodeURIComponent(m[1]);

    (async () => {
      try {
        const res = await api.post("/auth/session", { session_id: sessionId });
        // Persist token to localStorage to support cross-domain (qr.makrolog.page)
        // where third-party cookies are blocked by the browser.
        if (res.data?.session_token) setToken(res.data.session_token);
        setUser(res.data.user);
        // Clear hash and go to dashboard
        window.history.replaceState({}, document.title, "/dashboard");
        navigate("/dashboard", { replace: true, state: { user: res.data.user } });
      } catch (e) {
        const msg = e?.response?.data?.detail || "Anmeldung fehlgeschlagen.";
        setError(msg);
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen grid place-items-center bg-white p-6" data-testid="auth-callback-page">
      <div className="max-w-md w-full text-center">
        <div className="mx-auto grid place-items-center w-10 h-10 rounded-md bg-[#0A52FF] text-white mb-4">
          <Layers className="w-5 h-5" />
        </div>
        {!error ? (
          <>
            <div className="font-display text-xl font-semibold">Anmeldung läuft…</div>
            <div className="text-sm text-zinc-500 mt-1">Bitte einen Moment Geduld.</div>
          </>
        ) : (
          <>
            <div className="font-display text-xl font-semibold text-red-600">Anmeldung blockiert</div>
            <div className="text-sm text-zinc-700 mt-2">{error}</div>
            <button
              onClick={() => navigate("/login", { replace: true })}
              className="mt-6 inline-flex items-center px-4 h-10 rounded-md bg-zinc-900 text-white text-sm hover:bg-zinc-800"
              data-testid="callback-back-login"
            >
              Zurück zum Login
            </button>
          </>
        )}
      </div>
    </div>
  );
}
